import { render, staticRenderFns } from "./basic-info-subpage.vue?vue&type=template&id=7ae69bb0&lang=pug&"
import script from "./basic-info-subpage.vue?vue&type=script&lang=js&"
export * from "./basic-info-subpage.vue?vue&type=script&lang=js&"
import style0 from "./basic-info-subpage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports